/**
 * Load More Button
 * Handle progressive loading of search results
 */

import { elements } from '../core/elements.js';
import { state } from '../core/state.js';

// Will be injected by index.js
let renderResults = null;

/**
 * Set render results dependency
 */
export function setRenderResults(fn) {
  renderResults = fn;
}

/**
 * Render Load More button
 * Shows button if there are more results to display
 * @param {number} displayedCount - Number of results currently displayed
 * @param {number} totalCount - Total number of results available
 */
export function renderLoadMoreButton(displayedCount, totalCount) {
  if (!elements.pagination) {
    console.error('Pagination element (#pagination) not found in DOM');
    return;
  }

  console.log('renderLoadMoreButton called:', {
    displayedCount,
    totalCount,
    allFilteredHitsLength: state.allFilteredHits.length,
  });

  // Hide if all results are displayed
  if (displayedCount >= totalCount) {
    console.log('All results displayed, hiding button');
    elements.pagination.style.display = 'none';
    return;
  }

  elements.pagination.style.display = 'block';
  elements.pagination.innerHTML = '';

  // Create Load More button
  const loadMoreBtn = document.createElement('button');
  loadMoreBtn.className =
    'rd-search-results__load-more-button capsize btn_tertiary btn_large font-bold';
  loadMoreBtn.textContent = 'Load more camps';

  loadMoreBtn.addEventListener('click', (e) => {
    e.preventDefault();
    console.log('Load More clicked!');

    const previousDisplayed = state.displayedHits;
    console.log('Previous displayed:', previousDisplayed);

    // Increase displayed count
    state.displayedHits = Math.min(
      state.displayedHits + state.hitsPerPage,
      state.allFilteredHits.length
    );
    console.log('New displayedHits:', state.displayedHits);

    // Get ONLY the new hits to display (not all from beginning)
    const newHitsToDisplay = state.allFilteredHits.slice(
      previousDisplayed,
      state.displayedHits
    );
    console.log(
      'New hits to display:',
      newHitsToDisplay.length,
      'from index',
      previousDisplayed,
      'to',
      state.displayedHits
    );

    // Append new results (not replace)
    if (renderResults) {
      const currentQueryID = localStorage.getItem('algoliaQueryID');
      renderResults(
        newHitsToDisplay,
        state.totalHits || state.allFilteredHits.length,
        true,
        null,
        currentQueryID
      );
    }
  });

  elements.pagination.appendChild(loadMoreBtn);
  console.log('Load More button added to DOM');
}

console.log('📦 Load more module loaded');
